import { render, staticRenderFns } from "./CombinationsWarning.vue?vue&type=template&id=417b4a02&scoped=true"
import script from "./CombinationsWarning.vue?vue&type=script&lang=ts"
export * from "./CombinationsWarning.vue?vue&type=script&lang=ts"
import style0 from "./CombinationsWarning.vue?vue&type=style&index=0&id=417b4a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417b4a02",
  null
  
)

export default component.exports